// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dAB2","footer":"styles_footer__29xlb","passCodeTooltip":"styles_passCodeTooltip__3vin3"};